import { type CustomizationMachineTypes } from '@sg/shared-fe-features-customization';

import { type Context, type SelectedProduct } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getCustomizationInput(params: Params): CustomizationMachineTypes.Input {
  const { context, selectedProduct } = params;

  return {
    productSlug: selectedProduct.productSlug,
    restaurantSlug: context.restaurantSlug,
    isDelivery: context.isDelivery,
    lineItemId: undefined,
    ingredientAssetVersion: context.ingredientAssetVersion,
    isUpsellPricingEnabled: context.isUpsellPricingEnabled,
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  context: Context;
  selectedProduct: SelectedProduct;
};
